import _map from "lodash/map";
import _isEmpty from "lodash/isEmpty";
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classes from '@nerdwallet/base-styles/classes';
import { Li, List, Type } from '@nerdwallet/currency';
import { sanitizeNode } from './lib/utils';
import styles from './marketplace-product-card.module.less';

var Qualifications = function Qualifications(_ref) {
  var bullets = _ref.bullets,
      feesBullets = _ref.feesBullets,
      termLengths = _ref.termLengths,
      disclaimer = _ref.disclaimer;
  return /*#__PURE__*/React.createElement(Fragment, null, !_isEmpty(bullets) && /*#__PURE__*/React.createElement("div", {
    className: styles.contentSection
  }, /*#__PURE__*/React.createElement(Type, {
    bold: true
  }, "Qualifications"), /*#__PURE__*/React.createElement(List, null, _map(bullets, function (qualification) {
    return /*#__PURE__*/React.createElement(Li, {
      key: qualification
    }, sanitizeNode(qualification));
  }))), termLengths && /*#__PURE__*/React.createElement("div", {
    className: styles.contentSection
  }, /*#__PURE__*/React.createElement(Type, {
    bold: true
  }, "Available Term Lengths"), /*#__PURE__*/React.createElement(List, null, /*#__PURE__*/React.createElement(Li, null, sanitizeNode(termLengths)))), !_isEmpty(feesBullets) && /*#__PURE__*/React.createElement("div", {
    className: styles.contentSection
  }, /*#__PURE__*/React.createElement(Type, {
    bold: true
  }, "Fees"), /*#__PURE__*/React.createElement(List, null, _map(feesBullets, function (fee) {
    return /*#__PURE__*/React.createElement(Li, {
      key: fee
    }, sanitizeNode(fee));
  }))), disclaimer && /*#__PURE__*/React.createElement("div", {
    className: styles.contentSection
  }, /*#__PURE__*/React.createElement(Type, {
    className: classes('type-0')
  }, "Disclaimer: ", sanitizeNode(disclaimer))));
};

Qualifications.propTypes = {
  bullets: PropTypes.arrayOf(PropTypes.node),
  disclaimer: PropTypes.string,
  feesBullets: PropTypes.arrayOf(PropTypes.node),
  termLengths: PropTypes.string
};
Qualifications.defaultProps = {
  bullets: [],
  disclaimer: '',
  feesBullets: [],
  termLengths: ''
};
export default Qualifications;